import { generateStepOutput } from "@/utils/maaran";
import { useMutation } from "@tanstack/react-query";

export default function useGenerateStepOutput() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ sessionId, stepId, options }) =>
      generateStepOutput(sessionId, stepId, options),
  });
  return { mutateAsync, isPending };
}
